import React from 'react';
import { bool, node, object } from 'prop-types';
import { PlayArrow } from '@material-ui/icons';
import CFSlider from 'components/ContentfulFields/Slider';
import sliderStyles from './slider.scss';
import sliderItemStyles from './sliderItem.scss';

const Slider = (props) => {
  const {
    content,
    styles = {},
    itemStyles = {},
    arrowIcon = <PlayArrow />,
    hideDisabled = false,
  } = props;

  const altStyles = { ...sliderStyles, ...styles };
  const altItemStyles = { ...sliderItemStyles, ...itemStyles };

  return (
    <CFSlider
      document={content}
      altStyles={altStyles}
      altItemStyles={altItemStyles}
      backIcon={arrowIcon}
      nextIcon={arrowIcon}
      hideDisabled={hideDisabled}
      {...props}
    />
  );
};

Slider.propTypes = {
  content: object.isRequired,
  styles: object,
  itemStyles: object,
  arrowIcon: node,
  hideDisabled: bool,
};

export default Slider;
